import { useEffect } from 'react';

const PrivacyPage = () => {
  useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#05070A] text-white">
      <div className="max-w-4xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
        <div className="mb-8">
          <a href="/" className="text-blue-400 hover:text-blue-300 transition-colors inline-flex items-center gap-2">
            ← Back to V&V
          </a>
        </div>
        
        <div className="prose prose-invert max-w-none">
          <h1 className="text-4xl font-bold mb-4">Privacy Policy</h1>
          <div className="flex gap-6 text-gray-400 text-sm mb-8 pb-4 border-b border-gray-800">
            <span>Effective: 1 January 2026</span>
            <span>Last updated: 1 January 2026</span>
            <span>Governed by: Kenya Data Protection Act 2019</span>
          </div>
          
          <div className="bg-blue-500/10 border-l-4 border-blue-500 p-6 rounded-r-lg mb-8">
            <p className="text-gray-300">
              Vett & Venture Studio Limited (<strong className="text-white">"V&V"</strong>, <strong className="text-white">"we"</strong>, <strong className="text-white">"us"</strong>) is committed to protecting your personal data. This Policy explains what information we collect, how we use it, who we share it with, and what rights you have under the Kenya Data Protection Act 2019.
            </p>
          </div>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">1. Who We Are and How to Contact Us</h2>
          <p className="text-gray-300 leading-relaxed mb-4">
            Vett & Venture Studio Limited is the data controller for all personal data processed under this Policy. We are incorporated in Kenya and operate the Forge programme, the Problem Bank platform, the Foundry venture studio, and the Fix-and-Deliver service.
          </p>
          <p className="text-gray-300 leading-relaxed mb-4">
            Our designated Data Protection Contact can be reached at <a href="mailto:privacy@vettandventure.com" className="text-blue-400 hover:underline">privacy@vettandventure.com</a>. For any data-related enquiries, requests, or complaints, please use that address.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">2. What Personal Data We Collect</h2>
          <p className="text-gray-300 leading-relaxed mb-4">
            We collect identity data (name, ID number), contact data (email, phone), professional data (university, degree, employer), company data, problem data, assessment data, and usage data. We do not collect special category data unless you voluntarily provide it and consent to its use.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">3. Your Rights Under Kenyan Law</h2>
          <ul className="list-disc pl-6 text-gray-300 space-y-2 mb-4">
            <li><strong className="text-white">Right of access</strong> — You may request a copy of the personal data we hold about you.</li>
            <li><strong className="text-white">Right to rectification</strong> — You may ask us to correct inaccurate or incomplete data.</li>
            <li><strong className="text-white">Right to erasure</strong> — You may ask us to delete your personal data where there is no lawful basis to continue holding it.</li>
            <li><strong className="text-white">Right to restrict processing</strong> — You may ask us to pause processing your data in certain circumstances.</li>
            <li><strong className="text-white">Right to object</strong> — You may object to processing based on legitimate interests.</li>
            <li><strong className="text-white">Right to data portability</strong> — You may ask for your data in a portable format where processing is based on consent or contract.</li>
            <li><strong className="text-white">Right to withdraw consent</strong> — You may withdraw consent at any time.</li>
          </ul>
          <p className="text-gray-300 leading-relaxed mb-4">
            To exercise any of these rights, contact us at <a href="mailto:privacy@vettandventure.com" className="text-blue-400 hover:underline">privacy@vettandventure.com</a>.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8 mb-4">4. Contact Us</h2>
          <div className="bg-gray-900/50 border border-gray-800 rounded-lg p-6">
            <h3 className="text-lg font-semibold mb-2">Data Protection Contact</h3>
            <p className="text-gray-300">Vett & Venture Studio Limited</p>
            <p className="text-gray-300">Nairobi, Kenya</p>
            <p className="text-gray-300">Email: <a href="mailto:privacy@vettandventure.com" className="text-blue-400 hover:underline">privacy@vettandventure.com</a></p>
            <p className="text-gray-300">Phone: +254 745 665 732</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;